import { useTranslation } from 'react-i18next';

import { allowedTypes } from '@/features/documents/util/mimetype-util';
import { toast } from '@/shared/hooks/use-toast';

const MAX_FILE_SIZE_MB = 20;

export function useFileValidation() {
  const { t: tErrors } = useTranslation('document', { keyPrefix: 'Errors' });

  const validateFile = (file: File) => {
    const multiplier = 1024 * 1024;
    const maxSizeInBytes = MAX_FILE_SIZE_MB * multiplier;

    if (!allowedTypes.includes(file.type)) {
      toast({
        title: tErrors('file_type_not_allowed'),
        description: tErrors('file_type_not_allowed_description'),
        variant: 'destructive',
      });
      return false;
    }

    if (file.size > maxSizeInBytes) {
      toast({
        title: tErrors('file_too_large'),
        description: tErrors('file_size_limit', {
          size: `${MAX_FILE_SIZE_MB}MB`,
        }),
        variant: 'destructive',
      });
      return false;
    }

    return true;
  };

  return { validateFile };
}
